'use client';

import { useAuth } from '@/components/AuthProvider';
import { isOrganizationFeatureEnabled, type OrganizationFeature } from '@/lib/organization-features';

/** 表示ポリシーは現在組織だけから解決し、権限・契約判定は呼び出し元に残す。 */
export function useOrganizationFeature(feature: OrganizationFeature): boolean {
  const { authenticatedUser } = useAuth();
  const organization = authenticatedUser?.organization;
  // セッション fallback の仮組織と、取得済みの未設定（既定 ON）を区別する。
  if (!organization?.id || organization.id !== authenticatedUser?.currentOrganizationId
    || !organization.settings || typeof organization.settings !== 'object') return false;
  return isOrganizationFeatureEnabled(organization.settings, feature);
}
